import { HttpStatusCodes } from '@service-initiation/shared-clients-http';
import { logger } from '@service-initiation/shared-clients-osp-logger';
import {
  AQLeadType,
  type CreateMailInRequest,
  ServiceTypeCode,
} from '@service-initiation/shared-clients-tech-care-services';

import { createAppointment } from './createAppointment';

export type ShippingLabelResponse = {
  label_link?: string;
  tracking_code?: string;
  tracking_link?: string;
};

export type CreateMailInResponse = {
  error?: string;
  errorCode?: number;
  leadId?: number;
  shippingLabel?: ShippingLabelResponse;
};

export type CustomerDetailsForMailIn = {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
};

export const createMailIn = async (
  request: CreateMailInRequest
): Promise<CreateMailInResponse> => {
  try {
    const res = await createAppointment({
      appointmentDateAndTimeUTC: request.appointmentDateAndTimeUTC,
      aqLeadType: AQLeadType.MailIn,
      companyId: request.companyId,
      country: 'US',
      countryCode: 'us',
      customer: request.customerDetails,
      customerMessage: request.customerMessage,
      deviceRepairId: request.deviceRepairId,
      deviceTypeId: request.deviceTypeId,
      intentId: request.intentId,
      isInStoreAppointment: false,
      serviceTypeCode: ServiceTypeCode.MAIL_IN,
      storeId: request.storeId,
      subscribeToMarketingEmails: request.subscribeToMarketingEmails,
    });

    if (res.id) {
      return { leadId: res.id, shippingLabel: res.shipping_label };
    }
    if (res.errorCode === HttpStatusCodes.BadRequest) {
      const err = new Error('Create mail in request failed');
      logger.error(err, {
        data: {
          response: {
            data: res.error,
            status: res.errorCode,
          },
        },
      });
      return { error: 'An error occurred with mail in request' };
    }
  } catch (e) {
    const err = e as Error;
    err.message = 'Create mail in request failed - Some other Error';
    logger.error(err, {
      data: {
        response: {
          error: e,
        },
      },
    });
    throw err;
  }
  throw new Error(
    'Failed to create a mail in request, missing lead id or an unknown error'
  );
};
